interface NavItem {
  name: string;
  href: string;
  items?: NavItem[];
}

export const mainNavigation: NavItem[] = [
  {
    name: 'Solutions',
    href: '/solutions',
    items: [
      { name: 'AI Diagnostics', href: '/solutions/ai-diagnostics' },
      { name: 'Clinical Workflow', href: '/solutions/clinical-workflow' },
      { name: 'Patient Engagement', href: '/solutions/patient-engagement' },
      { name: 'Analytics Platform', href: '/solutions/analytics' },
    ],
  },
  {
    name: 'Products',
    href: '/products',
    items: [
      { name: 'Flagship Product', href: '/products/ai-platform' },
      { name: 'Clinical Tools', href: '/products/clinical-tools' },
      { name: 'Integration Hub', href: '/products/integration-hub' },
      { name: 'API Access', href: '#' },
    ],
  },
  {
    name: 'Company',
    href: '/company',
    items: [
      { name: 'About Us', href: '/about' },
      { name: 'Contact', href: '/contact' },
   
    ],
  },
  /*{
    name: 'Resources',
    href: '/resources',
    items: [
      { name: 'Documentation', href: '#' },
      { name: 'API Reference', href: '#' },
      { name: 'Case Studies', href: '#' },
      { name: 'Support', href: '#' },
    ],
  },*/
];

export const footerNavigation = {
  solutions: [
    { name: 'AI Diagnostics', href: '/solutions/ai-diagnostics' },
    { name: 'Clinical Workflow', href: '/solutions/clinical-workflow' },
    { name: 'Patient Engagement', href: '/solutions/patient-engagement' },
    { name: 'Analytics Platform', href: '/solutions/analytics' },
  ],
  company: [
    { name: 'About Us', href: '/company' },
    { name: 'Leadership', href: '/company/leadership' },
    { name: 'Careers', href: '/careers' },
    { name: 'Blog', href: '/blog' },
    { name: 'Contact', href: '/contact' },
  ],
  resources: [
    { name: 'Documentation', href: '/docs' },
    { name: 'API Reference', href: '/docs/api' },
    { name: 'Case Studies', href: '/resources/case-studies' },
    { name: 'Support', href: '/support' },
  ],
  legal: [
    { name: 'Privacy', href: '/privacy' },
    { name: 'Terms', href: '/terms' },
  ],
};